import React, { useState } from 'react';
import { Menu } from 'antd';
import { useParams } from 'react-router';
import * as _ from "lodash"
import { fAssetEdit } from '../../../../../helpers/RxServices';
import { Modal } from '../../../../../helpers/commonUi';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAsset } from '../../../../../stateManager/store/assets/action';
import { Http } from '../../../../../helpers/axois';
import { generateSectionalIds, useToast, deleteFields } from '../../../../../helpers/commonFunction';
import style from "../../../../../pages/navigation/navigation.module.sass"
import { updateForms } from '../../../../../stateManager/store/formCreation/action';

export const AssetTooltip: React.FC<any> = ({setSelectedId, id: assetId }) => {
  const dispatch = useDispatch();
  const assets = useSelector((state: any) => (state.assets.list));
  const orgId = useSelector((state: any) => (state.org.selectedOrg.id));
  const forms = useSelector((state: any) => state.formcreation);
  const params: any = useParams();
  const form = forms[params.formId];
  const [modalVisible, setModalVisible] = useState<boolean>(false)

  const { ErrorToast, SuccessToast } = useToast();

  const handleEdit = () => {
    fAssetEdit.sendMessage({ id: assetId })
    setSelectedId(null)
  }

  const replaceAsset = (fields: any[], asset: any) => {
    fields.forEach((field: any) => {
      if (field.isAsset && field.assetId === asset.assetId && asset.json) {
        const data = asset.json
        const fieldsToSkip = ["id", "fields", "assetInstanceId", "assetBindPrefix"]
        const assetFieldKeys = Object.keys(data).filter((el: any) => !fieldsToSkip.includes(el))

        assetFieldKeys.forEach((item: any) => {
          field[item] = data[item]
        })

        const fieldsToDelete = ["isAsset", "assetId", "assetInstanceId", "assetBindPrefix", "isChildAsset"]
        fieldsToDelete.forEach(el => delete field[el])

        if (field.type === "Container" || field.type === "Section") {
          const copyOfData = JSON.parse(JSON.stringify(data))
          deleteFields(copyOfData.fields, fieldsToDelete)
          const updatedFields = generateSectionalIds({ json: copyOfData }, field.id);
          field.fields = updatedFields.fields;
        }

        return
      }

      if (field.fields) {
        replaceAsset(field.fields, asset)
      }
    })
  }

  const handleDelete = () => {
    const asset = assets[assetId]
    const source = _.cloneDeep(form);
    source.forEach((tab: any) => replaceAsset(tab.fields, asset))

    dispatch(updateForms({
      id: params.formId,
      data: source
    }))
    setModalVisible(false)

    Http.delete(`/orgs/${orgId}/assets/${asset.id}`).subscribe((_res) => {
      dispatch(deleteAsset(assetId));
      SuccessToast("Successfully deleted")
    }, (err) => {
      ErrorToast(err.message)
    })
  }

  const handleCopyAssetID = async () => {
    try {
      await navigator.clipboard.writeText(assetId)
      SuccessToast("Copied Asset ID");
      setSelectedId(null)
    } catch (err) {
      console.error("failed to copy asset ID: ", err);
    }
  };

  return (
    <Menu style={{ width: "90px" }}>
      <Menu.Item >
        <div onClick={handleEdit}>
          <span>Edit</span>
        </div>
      </Menu.Item>
      <Menu.Item >
        <div onClick={() => {
          setSelectedId(null)
          setModalVisible(true)
        }}>
          <span>Delete</span>
        </div>
      </Menu.Item>
      <Menu.Item >
        <div onClick={handleCopyAssetID}>
          <span>Copy Id</span>
        </div>
      </Menu.Item>
      <Modal
        id="assetDelete"
        unmountOnCancel
        visible={modalVisible}
        title="DELETE ASSET"
        onCancel={() => setModalVisible(false)}
        footer={{
          enable: true,
          okText: 'DELETE',
          cancelText: 'CANCEL',
          onOk: handleDelete
        }}
      >
        <p className={style.modalMsg}>Are you sure you want to delete the asset?</p>
      </Modal>
    </Menu>
  )
}
